import React from 'react'
import { Box, Grid, IconButton, Alert, CircularProgress, Tooltip } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { TextInput, SelectInput, FileUploaderInput, ThemeButton } from '../../../../ui'
import { useCombos } from '../../../combos'
import { INSTALLERS_FORM_CONFIG } from '../../constants'
import { useSelector } from 'react-redux'

export const PrescriptorInstallersForm = ({
  formState,
  onChange,
  onSubmit,
  onClose,
  onSearchInstaller,
  isSearching,
  searchMessage,
  isLoading,
  isEdit,
}) => {
  const userEmpresasCa = useSelector((state) => state.global.empresa_cc_aa)
  const filteredCAs =
    userEmpresasCa?.map((ca) => ({ key: ca.id_empresa || ca.id, value: ca.nombre_cc_aa })) || []
  const combos = useCombos(['cod_zona_zeus'])

  const inputProps = {
    formState,
    onChange,
    combos: { ...combos, user_empresas_ca: filteredCAs },
    isEdit,
  }

  const cifValue = formState.cif || formState.nif

  return (
    <form onSubmit={onSubmit}>
      <Grid container spacing={3}>
        {searchMessage && (
          <Grid size={{ xs: 12 }}>
            <Alert severity="info">{searchMessage}</Alert>
          </Grid>
        )}

        <Grid size={{ xs: 12, sm: 6 }}>
          <TextInput {...INSTALLERS_FORM_CONFIG(inputProps).RAZON_SOCIAL} />
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <Box display="flex" alignItems="flex-end" gap={1}>
            <Box flexGrow={1}>
              <TextInput {...INSTALLERS_FORM_CONFIG(inputProps).CIF} />
            </Box>
            {!isEdit && (
              <Tooltip title="Buscar instalador por NIF/CIF">
                <span>
                  <IconButton
                    onClick={onSearchInstaller}
                    disabled={isSearching || !cifValue}
                    color="primary"
                    sx={{
                      mb: '4px',
                      bgcolor: 'action.selected',
                      '&:hover': {
                        bgcolor: 'action.focus',
                      },
                    }}
                  >
                    {isSearching ? <CircularProgress size={24} /> : <SearchIcon />}
                  </IconButton>
                </span>
              </Tooltip>
            )}
          </Box>
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <TextInput {...INSTALLERS_FORM_CONFIG(inputProps).TELEFONO} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextInput {...INSTALLERS_FORM_CONFIG(inputProps).WEB} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextInput {...INSTALLERS_FORM_CONFIG(inputProps).EMAIL} />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <Box p={2} bgcolor="grey.200" boxShadow={'1px 2px 4px rgba(0, 0, 0, 0.25)'}>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, sm: 8, md: 7 }}>
                <TextInput {...INSTALLERS_FORM_CONFIG(inputProps).CALLE} />
              </Grid>
              <Grid size={{ xs: 12, sm: 2, md: 3 }}>
                <TextInput {...INSTALLERS_FORM_CONFIG(inputProps).NUMERO} />
              </Grid>
              <Grid size={{ xs: 12, sm: 2, md: 2 }}>
                <TextInput {...INSTALLERS_FORM_CONFIG(inputProps).PISO} />
              </Grid>
              <Grid size={{ xs: 12, sm: 3, md: 3 }}>
                <TextInput {...INSTALLERS_FORM_CONFIG(inputProps).POLIGONO} />
              </Grid>
              <Grid size={{ xs: 12, sm: 9, md: 5 }}>
                <TextInput {...INSTALLERS_FORM_CONFIG(inputProps).POBLACION} />
              </Grid>
              <Grid size={{ xs: 12, sm: 3, md: 4 }}>
                <TextInput {...INSTALLERS_FORM_CONFIG(inputProps).COD_POSTAL} />
              </Grid>
            </Grid>
          </Box>
        </Grid>

        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6 }}>
            <FileUploaderInput
              {...INSTALLERS_FORM_CONFIG(inputProps).REGISTRO_INDUSTRIAL_DOCUMENTO}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <SelectInput {...INSTALLERS_FORM_CONFIG(inputProps).COMUNIDAD_AUTONOMA} />
          </Grid>
        </Grid>
      </Grid>
      <Box display="flex" justifyContent="space-around" pt={4} pb={1} flexWrap="wrap">
        <Box mb={[2, 0]}>
          <ThemeButton onClick={onClose} variant="outlined" labelM="sm" disabled={isLoading}>
            Cancelar
          </ThemeButton>
        </Box>
        <ThemeButton
          type="submit"
          color="primary"
          labelM="sm"
          loading={isLoading}
          disabled={isLoading}
        >
          {formState['id'] ? 'Guardar cambios' : 'Crear instalador'}
        </ThemeButton>
      </Box>
    </form>
  )
}
